import { useMemo } from 'react';

import { useRouter } from 'next/router';

import I18n from '~/src/common/services/I18n/I18n';
import { useGetDetailBySlug } from '~/src/queries/api-ecom/generated/api-ecom';
import { CatalogContentNotFound } from '~/src/screens/CatalogContent/ContentScreen/shared/CatalogContentNotFound/CatalogContentNotFound';
import { CatalogContentLinkQueryParams } from '~/src/screens/CatalogContent/ContentScreen/types';

import ProductScreenSkeleton from './components/ProductScreenSkeleton/ProductScreenSkeleton';
import { useProductContentAnalytics } from './hooks/useProductContentAnalytics';
import { useProductContentErrorHandler } from './hooks/useProductContentErrorHandler';
import { useProductContentRedirect } from './hooks/useProductContentRedirect';
import { useProductContentRefresh } from './hooks/useProductContentRefresh';
import { ProductContent } from './ProductContent';

const ProductScreen = () => {
  const {
    query: { slug },
  } = useRouter<CatalogContentLinkQueryParams>();

  const { data: product, error, refetch } = useGetDetailBySlug(slug);

  const analyticsProperties = useMemo(
    () => ({
      'current page path': `/produit/${slug}`,
      'current page type viewed': 'product page',
    }),
    [slug],
  );

  // Traitement speciaux,
  useProductContentErrorHandler(error);
  useProductContentAnalytics(product, slug, analyticsProperties);
  useProductContentRedirect(product, slug);
  // eslint-disable-next-line @typescript-eslint/no-misused-promises  -- auto-ignored when updating eslint
  useProductContentRefresh(refetch);

  // Gestion du loading et des erreurs
  if (error) return <CatalogContentNotFound title={I18n.t('view-product-screen.not-found')} />;
  if (product == null) return <ProductScreenSkeleton />;

  return (
    <ProductContent
      product={product}
      refetchProduct={refetch}
      analyticsProperties={analyticsProperties}
    />
  );
};

export default ProductScreen;
